// src/services/clientService.js
import api from './api';

const clientService = {
  // Get all clients
  getClients: async () => {
    const response = await api.get('/clients');
    return response.data;
  },

  // Get single client
  getClientById: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  // Create client
  createClient: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  // Update client
  updateClient: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  // Delete client
  deleteClient: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  sendClientEmail: async (id, payload = {}) => {
    const formData = new FormData();
    formData.append('to', payload.to || '');
    formData.append('cc', payload.cc || '');
    formData.append('subject', payload.subject || '');
    formData.append('message', payload.message || '');

    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file) => {
        formData.append('attachments', file);
      });
    }

    const response = await api.post(`/clients/${id}/send`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getEmailHistory: async (id, limit = 50) => {
    const response = await api.get(`/clients/${id}/email-history`, { params: { limit } });
    return response.data;
  },
};

export default clientService;
